import { render } from "./FuKuan.vue?vue&type=template&id=743aca02"
import script from "./FuKuan.vue?vue&type=script&lang=js"
export * from "./FuKuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__